import { useParams, useNavigate } from "react-router-dom";
import { knowledgeMap } from "../data/Knowledge";

export default function KnowledgeItemDetail({ dataKey }) {
  const { id } = useParams();
  const navigate = useNavigate();
  const item = knowledgeMap[dataKey]?.find((i) => i.id === id);

  if (!item) {
    return (
      <div className="py-24 text-center">
        <p>Item not found.</p>
        <button onClick={() => navigate(-1)} className="mt-4 underline">
          Go back
        </button>
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-4xl px-4 py-24 sm:px-6 lg:px-8">
      <button onClick={() => navigate(-1)} className="mb-6 text-sm font-bold text-brand">
        ← Back
      </button>
      <p className="text-sm font-bold uppercase tracking-wider text-ember">{item.category}</p>
      <h1 className="mt-2 font-display text-3xl font-bold text-ink">{item.title}</h1>
      <p className="mt-2 text-mute">{item.subtitle}</p>
      <div className="mt-6 flex gap-4 text-sm text-ink/60">
        <span>{item.date}</span>
        <span>{item.format} · {item.pages}p</span>
        <span>{item.size}</span>
      </div>
      <div className="mt-8 space-y-4">
        {item.overview?.map((p, i) => (
          <p key={i} className="leading-relaxed text-ink/80">{p}</p>
        ))}
      </div>
      {item.highlights?.length > 0 && (
        <ul className="mt-8 list-disc space-y-2 pl-5">
          {item.highlights.map((h, i) => <li key={i}>{h}</li>)}
        </ul>
      )}
    </div>
  );
}